import VerifySms from 'features/reactivation/challenges/VerifySms/VerifySms';
import React from 'react';

export default function VerifySmsPage() {
  return <VerifySms />;
}
